// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"formSection_wrapper__u76y9","wrapperContent":"formSection_wrapperContent__3lcae","content":"formSection_content__G35jG","emailLink":"formSection_emailLink__1OoNg"};